import { ROUTE_NAME_INTERNAL } from '@/lib/constant';

export default [
    {
        path: '/internal/qrcode',
        name: ROUTE_NAME_INTERNAL.QRCODE,
        meta: {
            title: '二维码',
        },
        component: () => import(/* webpackChunkName: "internal_qrcode" */ '@/pages/internal/qrcode.vue'),
    },
];
